import { api } from "./client";
import type {
  PlannedWorkout,
  PlanOverview,
  PlanWeekDetail,
} from "@/types";

export async function getPlanOverview(): Promise<PlanOverview> {
  const { data } = await api.get<PlanOverview>("/plan");
  return data;
}

export async function getCurrentWeek(): Promise<PlanWeekDetail> {
  const { data } = await api.get<PlanWeekDetail>("/plan/current");
  return data;
}

export async function getWeek(weekNumber: number): Promise<PlanWeekDetail> {
  const { data } = await api.get<PlanWeekDetail>(`/plan/week/${weekNumber}`);
  return data;
}

/** Flat list of all planned workouts across every plan week (for calendar view). */
export async function getAllPlannedWorkouts(): Promise<PlannedWorkout[]> {
  const { data } = await api.get<PlannedWorkout[]>("/plan/workouts");
  return data;
}

export async function getPlannedWorkout(id: number): Promise<PlannedWorkout> {
  const { data } = await api.get<PlannedWorkout>(`/plan/workouts/${id}`);
  return data;
}

export async function refreshPlanPreview(): Promise<void> {
  await api.post("/plan/regenerate-skeleton", null, { params: { refresh_previews: true } });
}
